import React, {useEffect, useState, useContext, useCallback} from "react";
import {PricingList} from "../pricing-list";
import {PricingPeriodSelector} from "./pricing-period-selector";
import {compareAsc, parse, parseISO} from "date-fns";
import {enUS} from "date-fns/locale";
import {CurrencyChooser} from "../currency-chooser";
import {useSelector} from "../../store";
import useTripPackages from "../../hooks/use-trip-packages";
import {TripDataContext} from "../../contexts/trip-context";
import useEmblaCarousel from "embla-carousel-react";
import AutoHeight from "embla-carousel-auto-height";
import {Box} from "@mui/material";

export const PricingContainer = () => {



    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: false,
        draggable: true
    }, [AutoHeight({destroyHeight: "auto"})])


    const {tripPageData} = useContext(TripDataContext)

    const {tripPackages, isFetchingPackages} = useTripPackages(tripPageData.tripId)

    const [packagePeriods, setPackagePeriods] = useState<string[]>([]);

    const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined)

    const [canScrollNext, setCanScrollNext] = useState(false)

    const [canScrollPrev, setCanScrollPrev] = useState(false)


    const {criteria} = useSelector((state) => state.trips);

    const {selectedPeriod} = criteria

    const onSelect = () => {
        //console.log("select happened")
        setSelectedIndex(emblaApi?.selectedScrollSnap() ?? 0)
    }


    useEffect(() => {
        if (emblaApi) {
            // Embla API is ready
            //console.log("empblaAPI ready")
            emblaApi.on("select", onSelect) // Add event listener

        }
        return () => {
            if (emblaApi) {
                emblaApi.off("select", onSelect) // Remove event listener
            }

        }
    }, [emblaApi])

    const getInitialSelectedPeriodIndex = (periodKeys: any[]) => {
        // periods could be in from_to format: 2018-01-01_2018-12-31
        // or could just be month: 2018-01
        let desiredDate = new Date();

        try {
            desiredDate = parse(selectedPeriod, "yyyy-MMM", new Date(), {locale: enUS});
        } catch (e) {
            console.error(e);
        }

        return periodKeys.reduce((obj, item, index) => {
            const [from, to] = item.split("_");

            const parsedFromDate = parseISO(from);

            return compareAsc(parsedFromDate, desiredDate) <= 0 ? index : obj;
        }, 0);
    };

    useEffect(() => {
        if (tripPackages) {
            const periodKeys = Object.keys(tripPackages.periods).sort();
            setPackagePeriods(periodKeys);
        }
    }, [tripPackages, isFetchingPackages]);


    useEffect(() => {
        console.log("loaded packagePeriods")
        if (packagePeriods) {
            const initialSelectedIndex = getInitialSelectedPeriodIndex(packagePeriods);

            console.log("emblaApi loaded?", !!emblaApi)

            emblaApi?.reInit({loop: false, draggable: true}, [AutoHeight({destroyHeight: "auto"})])
            emblaApi?.scrollTo(initialSelectedIndex)
            setCanScrollNext(emblaApi?.canScrollNext() ?? false)
            setCanScrollPrev(emblaApi?.canScrollPrev() ?? false)
        }

    }, [packagePeriods]);


    useEffect(() => {
        setCanScrollNext(emblaApi?.canScrollNext() ?? false)
        setCanScrollPrev(emblaApi?.canScrollPrev() ?? false)
    }, [selectedIndex]);


    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev()
    }, [emblaApi])

    const scrollNext = useCallback(() => {
        //console.log("canScrollNext:", emblaApi?.canScrollNext())
        if (emblaApi) emblaApi.scrollNext()
    }, [emblaApi])






    return (
        <>
            <CurrencyChooser/>
            <Box
                sx={{
                    border: "1px solid #696969",
                    backgroundColor: "#efefef",
                    mt: 2,
                    mb: 3,
                    pt: 3,
                    borderRight: {
                        xs: "none",
                        sm: 1
                    },
                    borderLeft: {
                        xs: "none",
                        sm: 1
                    },
                    mx: {
                        xs: -2,
                        sm: "unset"
                    }
                }}
            >
                <PricingPeriodSelector
                    hasPrev={canScrollPrev}
                    hasNext={canScrollNext}
                    packagePeriod={packagePeriods[selectedIndex ?? 0]}
                    onNext={scrollNext}
                    onPrev={scrollPrev}
                />
                <div className='embla'>
                    <div className='embla__viewport' ref={emblaRef}>
                        <div className='embla__container'>
                            {packagePeriods.map((periodKey, idx) => {
                                return <div key={idx} className='embla__slide'>
                                    <PricingList period={periodKey}
                                    />
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </Box>
        </>
    );
}

